import { frontendURL } from '../../../helper/URLHelper';
import HubApp from './HubApp.vue';

export const routes = [
  {
    path: frontendURL('hub'),
    name: 'hub',
    component: HubApp,
  },
];